var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import useFormApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-form-api";
import noop from "lodash/noop";
import React from "react";
import styled from "styled-components";
import { usePresentationComponent } from "../../../AppContext";
import { BUTTON_FORM_BACK, BUTTON_FORM_SUBMIT, FORM_BUTTONS } from "../../../classConstants";
import { getClassName } from "../../../helpers";
import { Flex } from "../../Flex";
import { Button } from "../Button/Button";
var goBack = function () {
    window.history.back();
};
var StyledFlex = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    button + button {\n        margin-left: 0;\n    }\n\n    gap: 1em;\n"], ["\n    button + button {\n        margin-left: 0;\n    }\n\n    gap: 1em;\n"])));
var RightAlignedFlex = styled(StyledFlex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    justify-content: flex-end;\n"], ["\n    justify-content: flex-end;\n"])));
export var FormButtons = function (props) {
    var _a = props.onCancel, onCancel = _a === void 0 ? goBack : _a, _b = props.onSubmit, onSubmit = _b === void 0 ? noop : _b, hideBackButton = props.hideBackButton, hideSubmitButton = props.hideSubmitButton, backLabel = props.backLabel, submitLabel = props.submitLabel, submitIcon = props.submitIcon, className = props.className, leftAligned = props.leftAligned, _c = props.getState, getState = _c === void 0 ? noop : _c;
    var ButtonRenderer = usePresentationComponent(props.context ? props.context + ".buttons" : "") || (leftAligned ? StyledFlex : RightAlignedFlex);
    var renderButtons = function () {
        var _a;
        return ((_a = props.buttons) === null || _a === void 0 ? void 0 : _a.length)
            ? props.buttons.map(function (_a, i) {
                var _b = _a.onClick, onClick = _b === void 0 ? noop : _b, buttonProps = __rest(_a, ["onClick"]);
                return (React.createElement(Button, __assign({ key: props.label || i }, buttonProps, { onClick: function (e) { return onClick(e, getState(), props.formApi); } })));
            })
            : (React.createElement(React.Fragment, null,
                renderBackButton(),
                renderSubmit()));
    };
    var renderBackButton = function () {
        if (hideBackButton)
            return null;
        return React.createElement(Button, { variant: "clear", className: BUTTON_FORM_BACK, key: "form-cancel", type: "button", disabled: props.disableCancel, onClick: function (e) { return onCancel(e, getState(), props.formApi); } },
            " ",
            backLabel,
            " ");
    };
    var renderSubmit = function () {
        if (hideSubmitButton)
            return null;
        return React.createElement(Button, { className: BUTTON_FORM_SUBMIT, icon: submitIcon, key: "form-submit", type: "submit", disabled: props.disableSubmit, onClick: function (e) { return onSubmit(e, getState(), props.formApi); } },
            " ",
            submitLabel,
            " ");
    };
    return (React.createElement(ButtonRenderer, { className: getClassName(className, FORM_BUTTONS) }, renderButtons()));
};
export var ReactiveFormButtons = function (props) {
    var formApi = useFormApi();
    return React.createElement(FormButtons, __assign({ getState: formApi.getState, formApi: formApi }, props));
};
var templateObject_1, templateObject_2;
